import { ActionContext, ActionTree, GetterTree, Module, MutationTree } from 'vuex';
import { useToast } from 'vue-toastification';
import { RootState } from '..';
import { Information } from './information.model';
import informationService from './information.service';

// namespace
export const INFORMATION_STORE_NAMESPACE = 'informationStore';

// state
interface InformationState {
  information: Information | null;
  status: 'init' | 'idle' | 'loading' | 'failed';
}

const initialState: InformationState = {
  information: null,
  status: 'init'
};

// mutation
const mutationConstant = {
  GET: 'get',
  PENDING: 'pending',
  FULFILLED: 'fulfilled',
  REJECTED: 'rejected'
};

const mutation: MutationTree<InformationState> = {
  [mutationConstant.GET]: (state: InformationState, information: Information) => {
    state.information = information;
  },
  [mutationConstant.PENDING]: (state: InformationState) => {
    state.status = 'loading';
  },
  [mutationConstant.FULFILLED]: (state: InformationState) => {
    state.status = 'idle';
  },
  [mutationConstant.REJECTED]: (state: InformationState) => {
    state.status = 'failed';
    window.location.href = '/';
  },
};

// action
const toast = useToast();
const actionConstant = {
  GET: 'get',
};

const action: ActionTree<InformationState, RootState> = {
  [actionConstant.GET](context: ActionContext<InformationState, RootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(mutationConstant.PENDING);
      informationService.Get()
        .then((response) => {
          context.commit(mutationConstant.GET, response.data);
          context.commit(mutationConstant.FULFILLED);
          resolve();
        })
        .catch(() => {
          context.commit(mutationConstant.REJECTED);
          toast.error('ไม่สามารถเรียกข้อมูลได้');
          reject();
        });
    });
  },
};

// getter
const getterConstant = {
  GET: 'get',
  STATUS: 'status'
};

const getter: GetterTree<InformationState, RootState> = {
  [getterConstant.GET]: (state: InformationState) => state.information,
  [getterConstant.STATUS]: (state: InformationState) => state.status,
};

// module
const module: Module<InformationState, RootState> = {
  namespaced: true,
  state: initialState,
  mutations: mutation,
  actions: action,
  getters: getter
};

// export
export const InformationGetter = {
  GET: `${INFORMATION_STORE_NAMESPACE}/${getterConstant.GET}`,
  STATUS: `${INFORMATION_STORE_NAMESPACE}/${getterConstant.STATUS}`
};

export const InformationAction = {
  GET: `${INFORMATION_STORE_NAMESPACE}/${actionConstant.GET}`,
};

export default module;
